import * as UI from "@iyk/ui"
import type React from "react"
import { FormState } from "../../../packages/use-form.ts"

export const FormButton = <A,>({
  state,
  children,
}: {
  state: FormState<A>
  children: React.ReactNode
}) =>
  FormState.$match(state, {
    Submitting: () => <LoadingButton children={children} />,
    Failed: () => <SubmitButton children={children} />,
    Idle: () => <SubmitButton children={children} />,
    Succeeded: () => <SubmitButton children={children} />,
  })

const SubmitButton = ({ children }: { children: React.ReactNode }) => (
  <UI.Button type="submit" kind="solid" size="lg" className="w-full">
    {children}
  </UI.Button>
)

const LoadingButton = ({ children }: { children: React.ReactNode }) => (
  <UI.Button type="submit" kind="solid" size="lg" className="w-full items-center" disabled={true}>
    <UI.Icon.Loading className="size-2.5" />
    {children}
  </UI.Button>
)
